<div class="modal-container">
  <div class="modal-header">
    <div class="header-div">
      <div class="empty-div"></div>
      <div class="header-center-text">
        <mat-select class="notranslate equip-list-dropdown" [ngClass]="{'mat-select-open': equipListDropDownOpen}" [(value)]="selectedEquipName" (selectionChange)="onClickViewDropdownChange($event.value)"   (openedChange)="equipListDropDownOpen = $event">
          @for (equip of equipList; track equip) {
            <mat-option class="hide-checkbox" [value]="equip.id">
              {{equip.dropDownName}}
            </mat-option>
          }
        </mat-select>
      </div>


      <div class="calendar-div">
        <div class="export-div">
          <button mat-button class="export-button" (click)="export()">EXPORT</button>
        </div>
        <input type="text" id="equip-date-range" class="equip-modal-datepicker" readonly ngxDaterangepickerMd
          [linkedCalendars]="true" [drops]="'down'" [minDate]="minDate" [maxDate]="maxDate" [opens]="'left'"
          [locale]="locale" [(ngModel)]="selected" (change)="setDateRange($event)"
          [alwaysShowCalendars]="true" [ranges]="ranges" [autoApply]="true" [showClearButton]="true"
          [showRangeLabelOnInput]="false" [closeOnAutoApply]="true" />
        <i matSuffix class="fa fa-calendar color-primary" aria-hidden="true"></i>
      </div>
    </div>
  </div>
  <div class="modal-content" #clickedViewModal id="clicked-view-modal">
    <div class="click-container">
      @if (selectedEquipData.class != 'coolingTowerSingleFan' && selectedEquipData.class != 'coolingTowerTwoFan' && selectedEquipData.class != 'coolingTowerFourFan' ) {
        <div class="equip-predefined-params d-flex justify-content-between notranslate"
          >
          @if (isLoading) {
            <div class="left-side-params-loader" id="left-side-params-loader">
              <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.leftTop" count="1"></ngx-skeleton-loader>
            </div>
          }
          @if (!isLoading) {
            <div class="left-side-params" [ngClass]="predefinedParameters?.leftPosition ? predefinedParameters?.leftPosition : ''">
              @if (predefinedParameters?.enable?.pointList[0].point) {
                <div class="param-container">
                  <span [ngClass]="predefinedParameters?.enable?.icon"></span>
                  <div class="enable_div">
                    <span [ngClass]="{'point-event-none': loginUserTypeData.isVofm}">{{predefinedParameters?.enable?.pointList[0].name}}
                      <mat-select matTooltip="{{showEnableTooltip(predefinedParameters?.enable)}}"
                        [matTooltipPosition]="'above'"
                        matTooltipClass="enable-tooltip"
                        [ngClass]="{'sharedMatDropDown': loginUserTypeData.isPublic, 'mat-select-open': enableDropdownOpen}"
                        [disabled]="loginUserTypeData.isPublic"
                        class="equip-running-state"
                        [(value)]="predefinedParameters.enable.pointList[0].pointValue"
                        (selectionChange)="onWritablePointsDropdownChange($event, predefinedParameters?.enable?.pointList[0].point,'predefined')"
                        (openedChange)="enableDropdownOpen = $event">
                        @for (template of equipRunningStates; track template) {
                          <mat-option class="hide-checkbox" [value]="template.value">
                            {{template.name}}
                          </mat-option>
                        }
                      </mat-select>
                    </span>
                  </div>
                </div>
              }
              @if (runHoursParameterVal) {
                <div class="param-container">
                  @if (runHoursParameterVal && predefinedParameters?.enable?.pointList[0].point) {
                    <span class="border_right-1"></span>
                  }
                  <span [ngClass]="predefinedParameters?.runHours?.icon"></span>
                  @if (runHoursParameterVal) {
                    <div class="run_hrs" [ngClass]="{'coolingTowerSingleFan': data?.class == 'coolingTowerSingleFan'}">
                      <span>{{predefinedParameters?.runHours?.pointList[0].name}}<span class="chiller-run-hrs p-l-5">{{runHoursParameterVal}}</span></span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (isLoading) {
            <div class="right-side-params-loader" >
              <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.rightTop" count="1"></ngx-skeleton-loader>
            </div>
          }
          @if (!isLoading) {
            <div [ngClass]="predefinedParameters?.rightPosition" class="right-side-params">
              @if (powerParameterVal) {
                <div class="param-container">
                  <span [ngClass]="predefinedParameters?.power?.icon"></span>
                  <div class="power_div" [ngClass]="{'coolingTowerSingleFan': data?.class == 'coolingTowerSingleFan'}">
                    <span>{{predefinedParameters?.power?.pointList[0].name}}<span class="power p-l-5">{{powerParameterVal}}</span></span>
                  </div>
                </div>
              }
              @if (energyConsumedParameterVal) {
                <div class="param-container">
                  @if (energyConsumedParameterVal) {
                    <span class="border_right-1"></span>
                  }
                  <span [ngClass]="predefinedParameters?.energy?.icon"></span>
                  <div class="energy_div"
                    [ngClass]="{'coolingTowerSingleFan': selectedEquipData?.class == 'coolingTowerSingleFan'}">
                    <span>{{predefinedParameters?.energy?.pointList[0].name}}<span class="energy_consumed p-l-5">{{energyConsumedParameterVal}}</span></span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      @if ((selectedEquipData.class == 'coolingTowerSingleFan' || selectedEquipData.class == 'coolingTowerTwoFan' || selectedEquipData.class == 'coolingTowerFourFan')) {
        <div
          class="equip-predefined-params notranslate">
          @if (isLoading) {
            <div class="left-side-params-loader" id="left-side-params-loader">
              <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.leftTop" count="1"></ngx-skeleton-loader>
            </div>
          }
          @if (!isLoading) {
            <div class="left-side-params" [ngClass]="{'ct1': selectedEquipData.class == 'coolingTowerSingleFan' || selectedEquipData.class == 'coolingTowerTwoFan' || selectedEquipData.class == 'coolingTowerFourFan'}">
              <div class="row w-100 align-items-center justify-content-end">
                @if (predefinedParameters?.enable?.pointsToDisplayCount) {
                  <div class="col-6 p-r-0">
                    @for (item of predefinedParameters?.enable?.pointList; track item; let i = $index) {
                      <div
                        class="predefined-enable-top">
                        @if (item?.point) {
                          <div class="d-flex">
                            <span [ngClass]="predefinedParameters?.enable?.icon"></span>
                            <span class="enable_div">
                              <span [ngClass]="{'point-event-none': loginUserTypeData.isVofm}">{{predefinedParameters?.enable?.pointList[i].name}}
                                <mat-select matTooltip="{{showCTEnableTooltip(item.point)}}"  [matTooltipPosition]="'above'" matTooltipClass="enable-tooltip" [ngClass]="{'sharedMatDropDown': loginUserTypeData.isPublic, 'mat-select-open': enableCTDropDownOpen[i]}" [disabled]="loginUserTypeData.isPublic" class="equip-running-state p-l-5"
                                  [value]="item?.point?.writableData?.[0]?.val"
                                  (selectionChange)="setWritablePointValue(item?.point, $event.value); onWritablePointsDropdownChange($event, item.point,'predefined')"
                                  (openedChange)="enableCTDropDownOpen[i] = $event">
                                  @for (template of item?.point?.options; track template) {
                                    <mat-option class="hide-checkbox"
                                      [value]="template?.value">
                                      {{template?.name}}
                                    </mat-option>
                                  }
                                </mat-select>
                              </span>
                            </span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (predefinedParameters?.runHours?.pointsToDisplayCount) {
                  <div class="col-6 p-l-0">
                    @for (item of predefinedParameters?.runHours?.pointList; track item; let i = $index) {
                      <div>
                        @if (item.pointValueToDisplay) {
                          <div class="d-flex preDefinedPointerTop">
                            @if (predefinedParameters?.runHours?.pointsToDisplayCount &&
                              predefinedParameters?.enable?.pointsToDisplayCount) {
                              <span class="border_right">
                              </span>
                            }
                            <div [ngClass]="predefinedParameters?.runHours?.icon"></div>
                            <div class="run_hrs"
                              [ngClass]="{'coolingTowerSingleFan': data?.class == 'coolingTowerSingleFan'}">
                              <span>{{predefinedParameters?.runHours?.pointList[i].name}}
                                <span
                                class="chiller-run-hrs p-l-5">{{item.pointValueToDisplay}}</span>
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (isLoading) {
            <div class="right-side-params-loader" >
              <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.rightTop" count="1"></ngx-skeleton-loader>
            </div>
          }
          @if (!isLoading) {
            <div [ngClass]="predefinedParameters?.rightPosition" class="right-side-params1">
              <div class="row w-100">
                @if (predefinedParameters?.power?.pointsToDisplayCount) {
                  <div class="col-6 p-r-0">
                    @for (item of predefinedParameters?.power?.pointList; track item; let i = $index) {
                      <div>
                        @if (item.pointValueToDisplay) {
                          <div class="d-flex preDefinedPointerTop">
                            <div [ngClass]="predefinedParameters?.power?.icon"></div>
                            <div class="power_div"
                              [ngClass]="{'coolingTowerSingleFan': data?.class == 'coolingTowerSingleFan'}">
                              <span>{{predefinedParameters?.power?.pointList[i].name}}
                                <span
                                  class="power p-l-5">{{item.pointValueToDisplay}}
                                </span>
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (predefinedParameters?.energy?.pointsToDisplayCount) {
                  <div class="col-6 p-l-0 p-r-0">
                    @for (item of predefinedParameters?.energy?.pointList; track item; let i = $index) {
                      <div>
                        @if (item.pointValueToDisplay) {
                          <div class="d-flex preDefinedPointerTop">
                            @if (predefinedParameters?.energy?.pointsToDisplayCount &&
                              predefinedParameters?.power?.pointsToDisplayCount) {
                              <span class="border_right"></span>
                            }
                            <div [ngClass]="predefinedParameters?.energy?.icon"></div>
                            <div class="energy_div"
                              [ngClass]="{'coolingTowerSingleFan': data?.class == 'coolingTowerSingleFan'}">
                              <span>{{predefinedParameters?.energy?.pointList[i].name}}
                                <span
                                class="energy_consumed p-l-5">{{item.pointValueToDisplay}}</span>
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <div class="equip-header" [ngStyle]="{'top': equipTitleTop}" [ngClass]="selectedEquipData?.class + '-equip-header'">
        <p class="equip-header-name">
          {{selectedEquipData.displayName}}
        </p>
        <p class="equip-header-details">
          {{selectedEquipData.equipData.brand}}
          {{selectedEquipData.equipData.model}}@if (selectedEquipData.equipData.capacity) {
          <span>- {{selectedEquipData.equipData.capacity}} </span>
        }
      </p>
    </div>
    <div class="clicked-view-content-container notranslate">
      @if (isLoading) {
        <div class="left-side-content-loader" id="left-side-content">
          <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.centerLeft" count="1"></ngx-skeleton-loader>
        </div>
      }
      <div [hidden]="isLoading" class="left-side-content"  [ngClass]="{'ct-fourFan': selectedEquipData?.class == 'coolingTowerFourFan','ct-twoFan': selectedEquipData?.class == 'coolingTowerTwoFan'}"  id="left-side-content">
        <div class="left-side-container" [ngStyle]="{'top':leftContainerTop}">
          <div id="bar-Chart-content"></div>
          <div [ngClass]="getPointListHeight(clickPointList)">
            <div class="pointlist-container" [ngStyle]="{'max-height': pointListHeight}">
              @for (equipData of clickPointList; track equipData; let i = $index) {
                <div>
                  @if (checkCustomPoint(equipData)) {
                    <div  class="d-flex m-t-10">
                      <div [title]="equipData?.toolTipName" class="point-name mr-auto">
                        {{equipData?.pointName}}
                      </div>
                      <!-- Custom point writable drop down -->
                      @if (equipData?.writable != undefined && equipData?.options?.length) {
                        <div>
                          <mat-select [ngClass]="{'sharedMatDropDown': loginUserTypeData?.isPublic || loginUserTypeData?.isVofm, 'mat-select-open': customPointDropDown[i]}" [disabled]="loginUserTypeData?.isPublic || loginUserTypeData?.isVofm"
                            class="custom-point-dropdown" [value]="equipData?.writableData?.[0]?.val"
                            (selectionChange)="setWritablePointValue(equipData, $event.value); onWritablePointsDropdownChange($event,equipData,'custom')"
                            (openedChange)="customPointDropDown[i] = $event">
                            @for (option of equipData.options; track option) {
                              <mat-option class="hide-checkbox" [value]="option.value">
                                {{option.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </div>
                      }
                      <!-- Custom point readonly Data -->
                      @if ((equipData?.writable == undefined && equipData?.data.length) || equipData?.options?.length == 0) {
                        <div class="point-value">
                          {{equipData?.pointValue}} {{equipData.unit}}
                        </div>
                      }
                      <!-- Custom point no data -->
                      @if (equipData?.writable == undefined && !equipData?.data.length) {
                        <div class="point-value">
                          NA
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      @if (isLoading) {
        <div class="middle-side-content-loader" id="middle-side-content-loader">
          <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj.loaderStyling.centerMiddle" count="1"></ngx-skeleton-loader>
        </div>
      }


      <div [hidden]="isLoading"  class="middle-side-content" id="middle-side-content">
        <div class="radialGraph" [ngStyle]="{'margin-top': circularWidgetPosition}" [ngClass]="selectedEquipData?.class + '_graph_div'" id="graph-wrapper">
          <div id="svg-div" class="circular-svg-div" style="position: relative;">
            <span class="circular-top-todaydate-text"
              [ngClass]="{'circular-top-todaydate-text-CT2':  selectedEquipData.class == 'coolingTowerTwoFan', 'circular-top-todaydate-text-CT4': selectedEquipData.class == 'coolingTowerFourFan'}"
            id="Time-12-pm"></span>
            <span class="circular-right-todaydate-text" id="Time-6-pm"></span>
            <span class="circular-bottom-todaydate-text" id="Time-12-am"></span>
            <span class="circular-left-todaydate-text"
              [ngClass]="{'circular-left-todaydate-text-CT4': selectedEquipData.class == 'coolingTowerFourFan', 'circular-left-todaydate-text-CT2':  selectedEquipData.class == 'coolingTowerTwoFan'}"
            id="Time-6-am"></span>
            <svg id="graphId-chart" class="graph-container">
              <circle id="energy-consumption-chart" r="180" stroke="#666666" stroke-width="0.5" fill="#333333"
                fill-opacity="0.6" />
              <circle id="status-chart" r="175" stroke="#666666" stroke-width="0.5" fill="#333333"
                fill-opacity="0.6" />
              <circle id="alert-chart" r="170" stroke="#666666" stroke-width="0.5" fill="#333333"
                fill-opacity="0.6" />
              <circle id="chiller-load-chart" r="165" stroke="#666666"
                stroke-width="0.5" fill="#333333" fill-opacity="0.6" />
              <line id="vertical-line" x1="225px" y1="0" x2="225px" y2="100%" stroke="#666666" stroke-width="1" />
              <line id="horizontal-line" x1="0" y1="200px" x2="100%" y2="200px" stroke="#666666" stroke-width="1" />
              <image id="center-img" height="200" width="200" y="150" x="150"></image>
            </svg>
          </div>
          <svg class="display_date_time" id="svg-date-time">
            <text id="text-1" font-size="11px" fill="#999999">12PM</text>
            <text id="text-2" font-size="11px" fill="#999999">6PM</text>
            <text id="text-3" font-size="11px" fill="#999999">12AM</text>
            <text id="text-4" font-size="11px" fill="#999999">6AM</text>
          </svg>
        </div>
        <div class="equip-command-div" id="command-div" [ngClass]="commandHeight">
          @for (item of predefinedParameters?.command?.pointList; track item; let i = $index) {
            <div id="command-point-{{i}}">
              <span [ngClass]="{'point-event-none': loginUserTypeData.isVofm}">{{
                predefinedParameters?.command?.pointList[i].name}}
                <mat-select [ngClass]="{'sharedMatDropDown': loginUserTypeData.isPublic, 'mat-select-open': commandDropDownOpen[i]}" [disabled]="loginUserTypeData.isPublic" [(value)]="item.pointValue"
                  (selectionChange)="onWritablePointsDropdownChange($event, item.point, 'predefined')"
                  (openedChange)="commandDropDownOpen[i] = $event">
                  @if (item?.point?.enum?.length) {
                    <span>
                      @for (template of item?.point?.enum; track template) {
                        <mat-option class="hide-checkbox" [value]="template.value">
                          {{template.name}}
                        </mat-option>
                      }
                    </span>
                  }
                </mat-select>
              </span>
            </div>
          }
        </div>
      </div>

      @if (isLoading && equipImageDetails?.url) {
        <div class="right-side-content-loader" id="right-side-content-loader">
          <ngx-skeleton-loader animation="progress" [theme]="responsiveStylingObj?.loaderStyling?.centerRight" count="1"></ngx-skeleton-loader>
        </div>
      }

      <div [hidden]="isLoading" class="right-side-content" id="right-side-content">
        @if ((selectedEquipData.class == 'pump1Vertical_forward' || selectedEquipData.class == 'pump1Vertical_backward' || selectedEquipData.class == 'coolingTowerSingleFan' || selectedEquipData.class == 'coolingTowerFourFan' || selectedEquipData.class == 'coolingTowerTwoFan') && !isLoading) {
          <circular-graph-widget [responsiveStylingObj]="responsiveStylingObj" [loginUserTypeData]="loginUserTypeData" [type]="isEquipChilledOrHotOrCondenser" [userInfo]="data.userInfo" [startDate]="formatStartDate" [endDate]="formatEndDate"
          [selectedEquipData]="selectedEquipData"></circular-graph-widget>
        }
      </div>
    </div>
  </div>
</div>
</div>